import React from 'react';
import GooglePayButton from '@google-pay/button-react';
import { GOOGLE_PAY_ENVIRONMENT } from '@reverbdotcom/env';
import { elog } from '@reverbdotcom/commons/src/elog';

interface Props {
  paymentRequest: google.payments.api.PaymentDataRequest
  onPaymentAuthorized: google.payments.api.PaymentAuthorizedHandler;
  onLoadPaymentData: () => any;
  onPaymentDataChanged?: google.payments.api.PaymentDataChangedHandler;
  onClick?: () => any;
}

export function CheckoutGooglePayButton({
  paymentRequest,
  onPaymentAuthorized,
  onLoadPaymentData,
  onPaymentDataChanged = undefined,
  onClick = undefined,
}: Props) {
  function handleClick() {
    logClickEvent(paymentRequest);

    if (onClick) {
      onClick();
    }
  }

  return (
    <div className="checkout-google-pay-button">
      <GooglePayButton
        className="checkout-google-pay-button__button"
        buttonType="short"
        buttonSizeMode="fill"
        buttonColor="black"
        environment={GOOGLE_PAY_ENVIRONMENT}
        paymentRequest={paymentRequest}
        onPaymentDataChanged={onPaymentDataChanged}
        onPaymentAuthorized={onPaymentAuthorized}
        onLoadPaymentData={onLoadPaymentData}
        onClick={handleClick}
        onError={(error) => logError(error)}
      />
    </div>
  );
}

function logClickEvent(paymentRequest: google.payments.api.PaymentDataRequest) {
  const merchantId = paymentRequest.merchantInfo?.merchantId;
  const countryCode = paymentRequest.transactionInfo?.countryCode;
  const currencyCode = paymentRequest.transactionInfo?.currencyCode;

  elog.info('checkout_google_pay_button.clicked', {
    payment_request: {
      merchant_id: merchantId,
      country_code: countryCode,
      currency_code: currencyCode,
    },
  });
}

function logError(error: Error | google.payments.api.PaymentsError) {
  const { data, jsError } = findErrorData(error);

  elog.error('checkout_google_pay_button.error', data, jsError);
}

function findErrorData(error: Error | google.payments.api.PaymentsError) {
  if (error instanceof Error) {
    return { data: {}, jsError: error };
  } else {
    return {
      data: {
        error: {
          status_code: error.statusCode,
          status_message: error.statusMessage,
        },
      },
      jsError: null,
    };
  }
}
